import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("vendora_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("vendora_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("vendora_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("vendora_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("vendora_token");
    setUser(null);
  };

  const hasRole = (...roles) =>
    !!user && (user.roles?.includes("super_admin") || user.roles?.some((r) => roles.includes(r)));

  const primaryRole = () => {
    if (!user) return null;
    const priority = [
      "super_admin",
      "supplier",
      "merchant",
      "creator",
      "affiliate",
      "fulfillment_partner",
      "service_provider",
      "customer",
    ];
    for (const r of priority) if (user.roles?.includes(r)) return r;
    return user.roles?.[0] || "customer";
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, hasRole, primaryRole, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
